import React from "react";
import PropTypes from "prop-types";
import DateField from "../../common/DateField";
import { displayDate } from "../../common/datePresentation";
import { useTranslation } from 'react-i18next';

function PaymentSchedulePreview({
  items,
  onChange,
  onRemove,
  readOnly,
}) {
  const { t: tr , i18n } = useTranslation();
  return (
    <div className="table-responsive mt-3">
      <table className="table table-sm">
        <thead>
          <tr>
            <th>{tr("manage:date_218")}</th>
            <th>{tr("manage:description_219")}</th>
            <th>{tr("manage:amount_131")}</th>
            <th>{tr("manage:status_146")}</th>
            {!readOnly && <th>{tr("manage:actions_134")}</th>}
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id}>
              <td>
                {readOnly ? displayDate(item.dueDate, i18n.language) : (
                  <DateField
                    aria-label={tr('common:scheduleDue', { description: item.description })}
                    className="form-control form-control-sm"
                    type="date"
                    value={item.dueDate}
                    onChange={event => onChange(item.id, "dueDate", event.target.value)}
                  />
                )}
              </td>
              <td>
                {readOnly ? item.description : (
                  <input
                    aria-label={tr('common:scheduleDescription', { description: item.description })}
                    className="form-control form-control-sm"
                    value={item.description}
                    onChange={event => onChange(item.id, "description", event.target.value)}
                  />
                )}
              </td>
              <td>
                {readOnly ? item.amount : (
                  <input
                    aria-label={tr('common:scheduleAmount', { description: item.description })}
                    className="form-control form-control-sm"
                    type="number"
                    value={item.amount}
                    onChange={event => onChange(item.id, "amount", Number(event.target.value || 0))}
                  />
                )}
              </td>
              <td>{item.status}</td>
              {!readOnly && (
                <td>
                  <button
                    type="button"
                    className="btn btn-sm manage-button manage-teal-button"
                    aria-label={tr('common:scheduleRemove', { description: item.description })}
                    onClick={() => onRemove(item.id)}
                  >{tr("manage:remove_136")}</button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

PaymentSchedulePreview.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    dueDate: PropTypes.string.isRequired,
    description: PropTypes.string,
    amount: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  })),
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  readOnly: PropTypes.bool,
};

PaymentSchedulePreview.defaultProps = {
  items: [],
  onChange: () => {},
  onRemove: () => {},
  readOnly: false,
};

export default PaymentSchedulePreview;
